const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
//@utils
const { formatText } = require('core/i18n').i18n;
// @ components
const AccountChequebookMovementsHeader = require('components/accounts/accountChequebookMovements/accountChequebookMovementsHeader/accountChequebookMovementsHeader');
const AccountChequebookMovementsTable = require('components/accounts/accountChequebookMovements/accountChequebookMovementsTable/accountChequebookMovementsTable');
//@commons
const { EmptyState } = require('commonsComponents/emptyState');

class CardLastMovements extends React.Component {
    constructor(props){
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildErrorState() {
        const primaryText = formatText('accountCheques-errorMessageCheques');
        return (
            <EmptyState
                primaryText={primaryText}
                iconType="nointernet-banking" />
        );
    }

    render() {
        const { onFilterSelect, immCheques, chequebookIndex, accountId } = this.props;

        const chequebookId = immCheques.get('byOrder').get(chequebookIndex);
        const immChequebook = immCheques.get('chequebooks').get(chequebookId);

        let tableContent;

        if (immChequebook && immChequebook.get('error')) {
            tableContent = this.buildErrorState();
        } else if (immChequebook) {
            tableContent = (
                <AccountChequebookMovementsTable
                    immChequebook={immChequebook}
                    chequebookFilter={immCheques.get('chequebookFilter')}
                    chequebookId={chequebookId}
                    accountId={accountId}
                />
            );
        }

        return (
            <div className="account-chequebook-movements-content">
                <AccountChequebookMovementsHeader
                    onFilterSelect={onFilterSelect}
                    chequebookFilter={immCheques.get('chequebookFilter')}
                />
                {tableContent}
            </div>
        )
    }
}

CardLastMovements.propTypes = {
    accountId: PropTypes.string.isRequired,
    chequebookIndex: PropTypes.string.isRequired,
    onFilterSelect: PropTypes.func.isRequired,
    immCheques: PropTypes.object.isRequired
}

module.exports = CardLastMovements;